export default __webpack_public_path__ + "static/christer-fhraeus-4653dc96574ce7edcb52060aa677b158.png";